module.exports = __webpack_public_path__ + "static/media/462539134_848922607455501_3456641841113178583_n-fotor-bg-remover-20241017183459.4ee908bb.png";